import { States } from 'safe'
import {
  SET_LOCATION,
  SET_LOCATIONS,
  UPDATE_LOCATION,
  DELETE_LOCATION,
  LocationsTypes,
} from '../actions/actionTypes'

const initialState: States.Location = {
  locations: [],
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: LocationsTypes
): States.Location => {
  let _locations, lIndex
  switch (action.type) {
    case SET_LOCATIONS:
      return { ...state, locations: action.payload }

    case SET_LOCATION:
      return { ...state, locations: [...state.locations, action.payload] }

    case UPDATE_LOCATION:
      _locations = [...state.locations]
      lIndex = _locations.findIndex((i) => i.id === action.payload.id)
      _locations[lIndex] = { ..._locations[lIndex], ...action.payload }
      return { ...state, locations: _locations }

    case DELETE_LOCATION:
      _locations = [...state.locations]
      lIndex = _locations.findIndex((i) => i.id === action.payload.id)
      _locations.splice(lIndex, 1)
      return { ...state, locations: _locations }

    default:
      return state
  }
}
